import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import MainPage from './components/Home';
import LoginPage from './components/Login';
import Instructions from './components/Instructions';
import ThankyouPage from './components/Thankyou';
import PageNotFound from './components/404';
import SystemCheckPage from './components/SystemCheck';
import ValidatePage from './components/Validate';
import FullScreenAlertPage from './components/FullScreenAlert';
import EnhancedFullScreenAlertPage from './components/EnhancedFullScreenAlert';
import { ProtectedRoute } from './components/Protected.Route';
import { ProtectedRouteAdmin } from './components/Protected.Route.Admin';
import Formvalid from './components/formvalid';
import Results from './components/Results';
import ExamScreen from './components/ExamScreen';
import TextBasedExamScreen from './components/TextBasedExamScreen';
import { AuthProvider } from './components/AuthContext';
import DynamicExamCreator from './components/DynamicExamCreator';
import DynamicExamScreen from './components/DynamicExamScreen';
import SubmissionResult from './components/SubmissionResult';
import SubmissionsList from './components/SubmissionsList';
import AdminDashboard from './components/AdminDashboard';
import ExamCodeEntry from './components/ExamCodeEntry';
import Admin from './components/Admin'
import CandidateAnalysis from './components/CandidateAnalysis';
import NewCandidateAnalysis from './components/NewCandidateAnalysis';
import Playground from './components/Playground';
import AITestGenerator from './components/AITestGenerator';

import MigrationTool from './components/DynamicExamCreator/MigrationTool';


require('dotenv').config();

class App extends Component {
  render() {
    return (
      <AuthProvider>
        <Router basename="/new">
          <Switch>
            {/* Admin Panel Routes (kept) */}
            <ProtectedRouteAdmin exact path="/admin-dashboard" component={AdminDashboard} />
            <ProtectedRouteAdmin exact path="/dynamic-exam-creator" component={DynamicExamCreator} />
            <ProtectedRouteAdmin exact path="/results" component={Results} />
            <ProtectedRouteAdmin exact path="/candidate-analysis" component={CandidateAnalysis} />
            <ProtectedRouteAdmin exact path="/new-candidate-analysis" component={NewCandidateAnalysis} />

            <ProtectedRouteAdmin exact path="/exam-code-entry" component={ExamCodeEntry} />
            <ProtectedRouteAdmin exact path="/migration-tool" component={MigrationTool} />
            <ProtectedRouteAdmin exact path="/playground" component={Playground} />
            <ProtectedRouteAdmin exact path="/ai-test-generator" component={AITestGenerator} />
            <ProtectedRouteAdmin exact path="/submissions/:examCode" component={SubmissionsList} />
            <ProtectedRouteAdmin exact path="/submission-result/:examCode/:submissionId" component={SubmissionResult} />
            {/* Candidate/User Routes (kept) */}
            <Route exact path="/" component={MainPage} />
            <Route exact path="/admin" component={Admin} />
            <Route exact path="/login" component={LoginPage} />
    
            <ProtectedRoute exact path="/examscreen" component={ExamScreen}/>
            <ProtectedRoute exact path="/textbasedexamscreen" component={TextBasedExamScreen}/>
            <ProtectedRoute exact path="/systemcheck" component={SystemCheckPage} />
            <ProtectedRoute exact path="/validate" component={ValidatePage} />   
            <ProtectedRoute exact path="/instructions" component={Instructions} />
            <ProtectedRoute exact path="/thankyou" component={ThankyouPage} />
            <ProtectedRoute exact path="/fullscreenalert" component={FullScreenAlertPage} />
            <ProtectedRoute exact path="/enhanced-fullscreen-alert" component={EnhancedFullScreenAlertPage} />
            <ProtectedRoute exact path="/formvalid" component={Formvalid} />
            <ProtectedRoute exact path="/dynamic-exam/:examCode" component={DynamicExamScreen} />
            <Route exact path="/404" component={PageNotFound} />
            <Redirect to="/404" />
          </Switch>
        </Router>
      </AuthProvider>
    );
  }
}

export default App;
